import { IBasicFile } from '@sdk/contracts';
import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

import { DocName, IconWrapper, Wrapper } from './DocumentDisplay.styles';

import { downloadFile, getFileDownloadInfo, getFileIcon } from '@/utils';

interface Props {
  file: IBasicFile;
  isEditable: boolean;
  handleDelete: (id: string) => void;
  type?: string;
}

export const DocumentDisplay = ({ file, isEditable, handleDelete, type }: Props) => {
  const { t } = useTranslation('CommonEventTranslations');

  const handleDownload = async () => {
    const { urlToDownload, filename } = getFileDownloadInfo(file);
    return downloadFile(urlToDownload, filename);
  };

  const iconName = getFileIcon(type ? type : file.name);
  return (
    <Wrapper onClick={handleDownload}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <IconWrapper iconName={iconName}>
          <Icon size={15.8} i={iconName} color="white" />
        </IconWrapper>
        <DocName>{file.name}</DocName>
      </div>
      {isEditable && (
        <div onClick={e => e.stopPropagation()}>
          <Popconfirm
            placement="left"
            onConfirm={() => handleDelete(file._id)}
            title={t('ARE_YOU_SURE_DELETE_THIS_ATTACHMENT')}>
            <Button
              type="link"
              icon={<Icon color={'black7'} i="TrashCan" />}
              size="large"
              onClick={e => e.stopPropagation()}
            />
          </Popconfirm>
        </div>
      )}
    </Wrapper>
  );
};
